import React, { Component } from 'react';
import { forwardRef } from 'react';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
//import MaterialTable from "material-table";
// Component styles
import Hidden from '@material-ui/core/Hidden';
import Tooltip from '@material-ui/core/Tooltip'
import { createVerify } from 'crypto';
import update from 'react-addons-update'
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import TextField from '@material-ui/core/TextField/index';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {getObjectiveAvailabilityResponse} from '../../../../../services/getObjectiveAvailabilityResponse'
import WindowModal from './WindowModal'
import WindowModalDelete from './WindowModalDelete'
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'  
import Replay from '@material-ui/icons/Replay';

moment.locale('es')


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    Replay: forwardRef((props, ref) => <Replay {...props} ref={ref} />)
}; 
class ControlObjective extends Component {

    
    constructor(props) {
        super(props);
        // console.log("props",props)
        const dateNow = new Date();
        const todayNumber = dateNow.getDate();
        const days=['D', 'L', 'M', 'M', 'J', 'V', 'S'];
        const lastDay = todayNumber.toString() + days[dateNow.getDay()]        

        var filterDays=(Object.keys(props.data.data[0]).filter(i=>i.length<=3&&i!=='kpi'))
        var listData=[]
        var max=0
        filterDays.map(day=>{
            var sample=props.data.dayGlobals.filter(i=>i["dia"]===day)[0]["muestra"]
            var historico=props.data.dayGlobals.filter(i=>i["dia"]===day)[0]["historicDay"]
          
            if(sample>max){
                max=sample
            }
            var newDict={}
            newDict["dia"]=day
            props.data.data.map(ele=>{
                if(ele["kpi"]==='Perf 15 seg.'){
                    ele["kpi"]='perf'
                }
                if(ele["kpi"]==='Fuera de Sla'){
                    ele["kpi"]='fuera'
                }
                if(ele["kpi"]==='Indisponibilidad/Error'){
                    ele["kpi"]='error'
                }
                if(ele["kpi"]==='Tiempo de Respuesta'){
                    ele["kpi"]='tiempo'
                }
                newDict[ele["kpi"]]=ele[day] 
            })
            newDict['muestra']=sample
            newDict['historico']=historico
            listData.push(newDict)
        })
        this.handleCloseControl= this.handleCloseControl.bind(this);
        this.handleControl= this.handleControl.bind(this);
        this.state = {
            dataObjective:this.props.data.showObjective,
            dialogOpen:false,
            dialogOpenDelete:false,
            value:0,
            data:listData,
            prevData:this.props.data,
            displayOther:false,
            labelNum:max,
            row:null,
            event:null,
            perf:0,
            error:0,
            out:0,
            errorMsg:"",
            sendValue:0,
            row:"",
            event:"",
            step:props.data.step,
            performance:props.data.sla_p,
            load:false,
            lastDay : lastDay
        }
        
    }

    handleControl =(time, changeTime)=>{
        const {prevData, data}=this.state
        //console.log("handlecontrol", time)
        let begin=moment(prevData.dateRange.selection.startDate).format("YYYY-MM-DD")
        let final=moment(prevData.dateRange.selection.endDate).add({'days':1}).format("YYYY-MM-DD")
        this.setState({
            load: true,  
        })
        getObjectiveAvailabilityResponse(prevData.user,begin, final,prevData.showObjective.objetivo_id, prevData.step.id_paso, prevData.sla_p, 29)
        .then( value => {
            //FILTRO POR LO QUE VIENE EN LA API
            // console.log(value)
            var filterAPi=(value[0].globales.filter(i=>i.dia===time).map(({dia, error_global, historicDay,muestra, performance_global,
                 parcial_global, promedio_global})=>({dia, error_global, historicDay, muestra, performance_global, parcial_global, promedio_global}))[0])
                        
            filterAPi["perf"]=filterAPi["performance_global"]
            filterAPi["error"]=filterAPi["error_global"]
            filterAPi["fuera"]=filterAPi["parcial_global"]
            filterAPi["tiempo"]=filterAPi["promedio_global"]
            filterAPi["historico"]=filterAPi["historicDay"]

            delete filterAPi["performance_global"]
            delete filterAPi["error_global"]
            delete filterAPi["parcial_global"]
            delete filterAPi["promedio_global"]
            delete filterAPi["historicDay"]
            //FILTRO DE ESTADO
            var dataState=data.filter(i=>i.dia===time)[0]
            //SE COLOCA ID EN NUEVO DICCIONARIO
            filterAPi["tableData"]=dataState["tableData"]
            var newData = data.map(u => u.dia !== filterAPi.dia ? u : filterAPi);
    
            this.setState({
                data: newData,
                load:false  
            })
        })
    }

    handleCloseControl =(value)=>{
        this.setState({
            dialogOpen: false,  
            dialogOpenDelete : false
        })
    }

    handleBack =()=>{
        this.props.handleBackControl()
    }

    handleCloseModal = event => {   
        this.setState({
            dialogOpen: false, 
            dialogOpenDelete : false, 
        })
    };
    
    close=()=>{
        this.props.handleCloseControl()
        
    }
    
    render() {
        const {classes}= this.props
        const {dialogOpen, value, data, displayOther,labelNum, prevData, errorMsg, row, event, step, performance, dataObjective, load, dialogOpenDelete,lastDay}=this.state
        
        if(load===true){
            return (
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                    >
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"
        
                        size={12}
                        thickness={3}
                        
                        />
                        Cargando Informacion....
                    </Typography>
                </Grid>
              );
        }else{
            return(
                <Grid
                    container
                    spacing={1}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"left"}}
                    >
                        <Button onClick={this.handleBack}>
                            <ArrowBackIosIcon/>
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography variant="h4">{prevData.showObjective.nombre}-{step.nombre_paso}</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                        style={{textAlign:"center"}}
                    >
                        <Typography variant="h6">Performance: {performance} segs.</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}
                    >
                        <MaterialTable
                            //style={{backgroundColor:"#656565"}}
                            icons={tableIcons}
                            columns={[
                                { title: "Día", field: "dia", /*defaultGroupOrder: 0 */},
                                { title: "Perf 15 seg", field: "perf" },
                                { title: "Fuera de SLA (seg)", field: "fuera"/*, type: "numeric"*/ },
                                { title: "Indisponibilidad/Error(seg)", field: "error"/*, type: "numeric"*/},
                                { title: "Tiempo de Respuesta (seg)", field: "tiempo"/*, type: "numeric"*/},
                                { title: "Muestra", field: "muestra"/*, type: "numeric"*/},
                            ]}
                            data={data}
                              actions={[
                                rowData =>({
                                    disabled :rowData.dia === lastDay,
                                    icon: Edit,
                                    tooltip : 'Editar Registros',
                                    onClick: (event,rowData) => {
                                    this.setState({dialogOpen: true, row:rowData, event:event});
                                  }
                                }),

                                rowData =>({
                                    disabled:!rowData.historico ,
                                    icon: Replay,
                                    tooltip : 'Restablecer Registros',
                                    onClick: (event,rowData) => {
                                        this.setState({dialogOpenDelete: true, row:rowData, event:event});
                                       }
                                })
                              ]}
                            title=" "
                            localization={{
                                /*grouping: {
                                    groupedBy: 'Agrupar por:',
                                    placeholder: 'Arrastre los encabezados aquí, para agrupar',
                                },*/
                                body: {
                                    emptyDataSourceMessage: 'No hay datos'
                                },
                                toolbar: {
                                    searchTooltip: 'Buscar',
                                    searchPlaceholder: 'Buscar'
                                },
                                pagination: {
                                    labelRowsSelect: 'Filas',
                                    labelDisplayedRows: ' {from}-{to} de {count}',
                                    firstTooltip: 'Pri. pág.',
                                    previousTooltip: 'Pág. previa',
                                    nextTooltip: 'Sig. pág.',
                                    lastTooltip: 'Últ. pág'
                                }
                            }}
                            options={{
                                grouping: false
                            }}
                        />
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={dialogOpen}
                            onClose={this.handleCloseModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={dialogOpen}>
                                <WindowModal row={row}  handleCloseControl={this.handleCloseControl} handleControl={this.handleControl}
                                 dataObjective={dataObjective} dates={this.props.data.dateRange.selection}/>
                            </Fade>
                        </Modal>

                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={dialogOpenDelete}
                            onClose={this.handleCloseModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >                                    
                            <Fade in={dialogOpenDelete}>
                                <WindowModalDelete row={row}  handleCloseControl={this.handleCloseControl} handleControl={this.handleControl}
                                 dataObjective={dataObjective} dates={this.props.data.dateRange.selection}/>
                            </Fade>
                        </Modal>
                    </Grid>
                </Grid>
            )
        }
        
        
    }
}


//export default (Movistar);

export default compose(withStyles(styles))(ControlObjective);


// WEBPACK FOOTER //
// ./src/layouts/components/content/Control/ControlObjective/index.jsx